'use strict';

module.exports = function sortDesc() {
  return this.sort().reverse();
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/collect.js/dist/methods/sortDesc.js
// module id = ./node_modules/collect.js/dist/methods/sortDesc.js
// module chunks = 0